import useUser from './useUser';
import { AxiosResponse } from 'axios';
import axios from 'axios';
import { URL_ORDERS } from 'constants/url';
import { IOrderProducts } from 'interfaces/orderTracking.interface';

export default function useOrderTracking() {
  const { jwt } = useUser();

  const headers = {
    Authorization: `Bearer ${jwt}`
  };

  const getOrderTrackingByOrderNumber = async (id: string): Promise<IOrderProducts[]> => {
    return axios.get(`${URL_ORDERS}/trace/${id}`, { headers }).then((response: AxiosResponse) => {
      return response.data.products;
    });
  };

  return {
    getOrderTrackingByOrderNumber
  };
}
